import { FileIcon } from "@comet/admin";
import { Button, CircularProgress } from "@mui/material";
import { type FunctionComponent, type PropsWithChildren, type ReactNode } from "react";
import { FormattedMessage } from "react-intl";
import styled from "styled-components";

import { type ExportApi } from "./usePagedCSVExport";

interface Props {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    exportApi: ExportApi<any>;
    onClick?: () => void;
    loadingComponent?: ReactNode;
}

export const StyledButton = styled(Button)`
    && {
        margin-top: 20px;
    }
`;

export const CSVExportButton: FunctionComponent<PropsWithChildren<Props>> = ({ onClick, children, exportApi, loadingComponent }) => {
    const onClickButtonPressed = () => {
        if (onClick != null) {
            onClick();
        } else {
            exportApi.exportTable();
        }
    };

    const { loading, progress } = exportApi;

    return (
        <StyledButton
            color="inherit"
            onClick={onClickButtonPressed}
            variant="text"
            startIcon={
                loading ? (
                    <>
                        {loadingComponent ? (
                            loadingComponent
                        ) : (
                            <CircularProgress size={23} variant={progress ? "determinate" : "indeterminate"} value={progress} />
                        )}
                    </>
                ) : (
                    <FileIcon fileType="application/msexcel" />
                )
            }
        >
            {children != null ? (
                children
            ) : (
                <FormattedMessage id="cometAdmin.table.csvExportButton" defaultMessage="Liste exportieren" description="Export Button" />
            )}
        </StyledButton>
    );
};
